import { configureStore } from "@reduxjs/toolkit";
import { LoaderSlice } from "./slices/LoaderSlice";

export const store = configureStore({
    reducer: {
        loader: LoaderSlice.reducer
    }
})